module.exports = __webpack_public_path__ + "static/media/steve-messam.db51c407.jpg";